import React, { useEffect, useRef, useState } from 'react';
import { FileWithMeta, IUploadDocumentModal } from "./type/upload-document-modal.types";
import UploadDocumentModalView from "./upload-document-modal.view";
import {
    getMetData,
    uploadDocument
} from "./action/upload-document-modal.actions";
import { DOCUMENT_VALIDATION } from "../document-uploader/utils/document-validation.constant";
import { Document_Type } from "../../../constant/constant";
import { MetaData } from "../../../domains/models/document";
import {
    getMetaValuesFromUI,
    getSystemFieldsValue,
    getSystemMetaFields,
    getUIMetaFields
} from "./utils/document-utils";
import "../../../styles/component/upload-document-modal.scss"



const UploadDocumentModal: React.FC<IUploadDocumentModal> = (props) => {

    const documentTypeRef = useRef<any>(null);
    const [selectedDocumentType, setSelectedDocumentType] = useState<keyof typeof Document_Type>();
    const [uiMetaFields, setUIMetaFields] = useState<MetaData[]>();
    const [systemMetaFields, setSystemMetaFields] = useState<MetaData[]>();

    useEffect(() => {
        if (!props.open) {
            setSelectedDocumentType(undefined);
            setUIMetaFields(undefined);
            setSystemMetaFields(undefined);
        }
    }, [props.open]);

    useEffect(() => {
        documentTypeRef.current = props.documentType || selectedDocumentType;

        getMetaData();

    }, [props.documentType, selectedDocumentType, props.open]);


    async function getMetaData() {
        const docType = documentTypeRef.current;
        if (!docType) return;

        const res = await getMetData(docType);
        const uiMetaFields = getUIMetaFields(res);
        const systemMetaFields = getSystemMetaFields(res);
        setUIMetaFields(uiMetaFields);
        setSystemMetaFields(systemMetaFields);
    }

    function handleDocTypeChange(val: keyof typeof Document_Type) {
        setSelectedDocumentType(val);
        if (props.onDocumentTypeChange)
            props.onDocumentTypeChange(val);
    }

    async function handleFileSubmit(metaFiles: FileWithMeta[]) {

        let docType = (props.documentType || selectedDocumentType);
        let res;
        const rcFiles = metaFiles.map((f) => f.file);

        if (docType) {
            const finalMetaData = metaFiles.reduce((acc, item, index) => {
                const systemMetaValue = getSystemFieldsValue(systemMetaFields ?? [], item.file);
                const uiMetaValues = getMetaValuesFromUI(uiMetaFields ?? [], item.meta ?? {});

                acc[index] = [...systemMetaValue, ...uiMetaValues];
                return acc;
            }, {} as Record<number, any>);

            res = await uploadDocument(rcFiles, docType, props.documentNumber, props.employeeId, finalMetaData, props.documentPurpose);
            props.handleUploadedFileRes(res);
        }
    }

    const documentValidationsByType = Object.entries(DOCUMENT_VALIDATION).find(
        ([key]) => key === (props.documentType ? props.documentType : selectedDocumentType)
    )?.[1];


    return (
        <UploadDocumentModalView
            {...props}
            selectedDocumentType={selectedDocumentType}
            metaData={uiMetaFields}
            documentValidationsByType={documentValidationsByType}
            handleFileSubmit={handleFileSubmit}
            handleDocTypeChange={handleDocTypeChange}
        />
    )
}

export default UploadDocumentModal;
